// extracted by mini-css-extract-plugin
export default {"outletContainer":"Layout_outletContainer__0KFr4"};